import * as React from 'react';
import Reaptcha from 'reaptcha';

export interface RecaptchaProps {
  theme: 'light' | 'dark';
  sitekey: string;
  className?: string;
  size?: 'compact' | 'normal' | 'invisible';
  badge?: 'bottomright' | 'bottomleft' | 'inline';
  tabindex?: number;
  onLoad?: () => void;
  onRender?: () => void;
  onVerify: (a: string) => void;
  onExpire?: () => void;
  onError?: () => void;
}

const Recaptcha = (props: RecaptchaProps) => {
  return <Reaptcha {...props} />;
};
export default Recaptcha;
